export default {
  disabled: {
    title: 'Billing is not managed on the platform',
    description:
      'Subscriptions and invoices are not available because billing between you and your restaurants is settled outside the platform. Payouts, statements and reports remain available.',
  },
};
